export default __webpack_public_path__ + "static/media/tony_lose.adce6c93.png";